import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "frame-a-header-title" }
const _hoisted_2 = { id: "frame-header-title-d" }
const _hoisted_3 = { id: "frame-header-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_main_show = _resolveComponent("main-show")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_left_menu = _resolveComponent("left-menu")!
  const _component_tab_menu = _resolveComponent("tab-menu")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"height":"100%"} }, {
    default: _withCtx(() => [
      (_ctx.showHeader)
        ? (_openBlock(), _createBlock(_component_a_layout_header, {
            key: 0,
            style: {"padding":"0px 10px"}
          }, {
            default: _withCtx(() => [
              (_ctx.showHeader)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    id: "frame-header"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_1, [
                              _createTextVNode(_toDisplayString(_ctx.moduleName) + " ", 1),
                              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.designBy), 1)
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                              _renderSlot(_ctx.$slots, "frame-header-menu", {}, undefined, true)
                            ])
                          ])
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      (_ctx.showMode == 'vertical' || _ctx.showMode == 'inline')
        ? (_openBlock(), _createBlock(_component_a_layout_content, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, {
                id: "frame-body",
                style: _normalizeStyle({
        top: _ctx.showHeader == true ? '48px' : '0px',
        height: '100%',
      })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_main_show, {
                    hideMenu: _ctx.state.hideMenu,
                    xs: _ctx.state.xs,
                    sm: _ctx.state.sm,
                    md: _ctx.state.md,
                    lg: _ctx.state.lg,
                    xl: _ctx.state.xl,
                    xxl: _ctx.state.xxl,
                    xxxl: _ctx.state.xxxl,
                    showQueryMenu: _ctx.showQueryMenu,
                    theme: _ctx.theme,
                    searchName: _ctx.state.searchName,
                    collapseWidth: _ctx.state.collapseWidth,
                    showMode: _ctx.showMode,
                    ifShowTab: _ctx.ifShowTab,
                    selectKey: _ctx.state.selectKey,
                    modules: _ctx.showModules,
                    onMenuBtnClick: _ctx.handleChangeMenu,
                    onShowMenu: _ctx.handleShowMenu,
                    onMenuitemClick: _ctx.handleMenuClick,
                    onMenuSearch: _ctx.handleSearch
                  }, null, 8, ["hideMenu", "xs", "sm", "md", "lg", "xl", "xxl", "xxxl", "showQueryMenu", "theme", "searchName", "collapseWidth", "showMode", "ifShowTab", "selectKey", "modules", "onMenuBtnClick", "onShowMenu", "onMenuitemClick", "onMenuSearch"])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_a_layout_content, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_layout, { style: {"height":"100%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_layout_header, { style: {"padding":"0px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_left_menu, {
                        ref: "leftMenu",
                        onShowMenu: _ctx.handleShowMenu,
                        onMenuitemClick: _ctx.handleMenuClick,
                        onMenuSearch: _ctx.handleSearch,
                        "menu-tree": _ctx.showModules,
                        showMode: _ctx.showMode,
                        theme: _ctx.theme,
                        showQueryMenu: _ctx.showQueryMenu
                      }, null, 8, ["onShowMenu", "onMenuitemClick", "onMenuSearch", "menu-tree", "showMode", "theme", "showQueryMenu"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_layout_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_tab_menu, {
                        ref: "tabMenu",
                        ifShowTab: _ctx.ifShowTab,
                        selectKey: _ctx.state.selectKey,
                        "menu-tree": _ctx.showModules
                      }, null, 8, ["ifShowTab", "selectKey", "menu-tree"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 3
  }))
}